// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-table-head[data-v-bfc1b106] {\n  padding: 0 0.5rem;\n}", "",{"version":3,"sources":["webpack://assets/ui/table/table-head.vue","webpack://table-head.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;ACAF","sourcesContent":["\n.default-table-head {\n  padding: 0 0.5rem;\n}\n",".default-table-head {\n  padding: 0 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
